import * as React from "react";
const SvgPlusSign = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.25 10.25H9.75V14.75H8.25V10.25H3.75V8.75H8.25V4.25H9.75V8.75H14.25V10.25Z", fill: "white" }));
export default SvgPlusSign;
